import React from "react";
import { STEPS } from "@constants/commonConstants";
import { useLoanRouteController } from "@hooks/useLoanRouteController";
import {
  createFormStepNavigator,
  declineInProgressNavigation,
  declineNavigation,
  errorRedirectNotFoundInvalid,
  errorRedirectNotRetrievable,
  thankYouNavigation,
  verifyNavigation,
  mismatchedBrandNavigation
} from "./navigators";
import { useSelector } from "react-redux";


const pageNavigators = STEPS.map(({path, step}) => 
  createFormStepNavigator(path, step));

const navigators = [
  mismatchedBrandNavigation,
  verifyNavigation,
  thankYouNavigation,
  errorRedirectNotFoundInvalid,
  errorRedirectNotRetrievable,
  declineNavigation,
  declineInProgressNavigation,
  ...pageNavigators
];

export const PersonalLoanRouteController = () => {
  const loanFormState = useSelector(state => state.loanForm);

  const { hasFetchedLoanForm } = loanFormState;
  
  useLoanRouteController(navigators, loanFormState, hasFetchedLoanForm);

  return <>{/* Left intentionally blank */}</>
};

export const __TEST__ = {
  navigators,
}